// extracted by mini-css-extract-plugin
module.exports = {"descriptionWrapper":"EmployeeDutyRosterStatistic_descriptionWrapper__7s31_","negativeNumber":"EmployeeDutyRosterStatistic_negativeNumber__2n4uC"};